import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { Panel } from "~/components/AssetModal/Panel/Panel";
import { CommentsTabButton } from "~/components/AssetModal/Panel/Tabs/components/CommentsTabButton";
import { CustomFieldsTabButton } from "~/components/AssetModal/Panel/Tabs/components/CustomFieldsTabButton";
import { InfoTabButton } from "~/components/AssetModal/Panel/Tabs/components/InfoTabButton";
import { PublicAssetModalInfoPanel } from "~/components/PublicAssetModal/components/PublicAssetModalInfoPanel";
import { PublicCustomFieldsPanelContainer } from "~/components/PublicAssetModal/shared/PublicCustomFieldsPanelContainer";
import { PublicBoardAssetCommentsPanelContainer } from "~/components/PublicBoardAsset/components/PublicBoardAssetCommentsPanelContainer";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { useOpenPublicCommentsPanelOnMount } from "~/hooks/useOpenPublicCommentsPanelOnMount";
import { AssetModalPanel, useAssetModalPanelContext } from "~/providers/AssetModalPanelContextProvider";
import { canSeeAssetCustomFields, canViewAssetDiscussions } from "~/utils/permissions/assetPermissions";
export const PublicBoardAssetModalPanel = /*#__PURE__*/ memo((param)=>{
    let { showArrows } = param;
    const { panel } = useAssetModalPanelContext();
    const { permissions } = usePublicPermissions();
    const canViewComments = canViewAssetDiscussions(permissions);
    const canViewCustomFields = canSeeAssetCustomFields(permissions);
    useOpenPublicCommentsPanelOnMount();
    const renderPanel = useMemo(()=>{
        switch(panel){
            case AssetModalPanel.FIELDS:
                return canViewCustomFields ? /*#__PURE__*/ _jsx(PublicCustomFieldsPanelContainer, {}) : null;
            case AssetModalPanel.INFO:
                return /*#__PURE__*/ _jsx(PublicAssetModalInfoPanel, {
                    permissions: permissions
                });
            case AssetModalPanel.COMMENTS:
                return canViewComments ? /*#__PURE__*/ _jsx(PublicBoardAssetCommentsPanelContainer, {}) : null;
            default:
        }
    }, [
        canViewComments,
        canViewCustomFields,
        panel,
        permissions
    ]);
    const tabs = useMemo(()=>/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                canViewComments && /*#__PURE__*/ _jsx(CommentsTabButton, {}),
                canViewCustomFields && /*#__PURE__*/ _jsx(CustomFieldsTabButton, {}),
                /*#__PURE__*/ _jsx(InfoTabButton, {})
            ]
        }), [
        canViewComments,
        canViewCustomFields
    ]);
    return /*#__PURE__*/ _jsx(Panel, {
        tabsBottomPadding: !!showArrows ? 80 : undefined,
        panel: renderPanel,
        tabs: tabs
    });
});
PublicBoardAssetModalPanel.displayName = "PublicBoardAssetModalPanel";
